export default __webpack_public_path__ + "static/media/LAS1000.34I-43774_-26145_0.e41d2be9.jpg";